<template>
  <svg
    width="94"
    height="94"
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_10_121)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M73.0116 41.8262C73.5988 42.0349 73.9943 42.5886 74 43.2121C74.0028 43.8356 73.6187 44.395 73.0344 44.6152L51.6101 52.6096L43.6157 74.0339C43.3956 74.6182 42.8362 75.0022 42.2127 74.9994C41.5892 74.9937 41.0355 74.5989 40.8267 74.0111L24.0862 26.9818C23.8945 26.4424 24.0278 25.8409 24.4339 25.4341C24.8401 25.0272 25.4422 24.8946 25.9816 25.0863L73.0116 41.8262Z"
        fill="#ff7b00"
      />
    </g>
    <circle
      cx="47"
      cy="47"
      r="44.5"
      stroke="#ff7b00"
      stroke-width="5"
    />
    <defs>
      <clipPath id="clip0_10_121">
        <rect
          width="50"
          height="50"
          fill="white"
          transform="translate(24 25)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
